import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation",
  "use": "exclamation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"exclamation\"><path d=\"m11.865 14.354-.656-4.656V6.546h2.176v3.152l-.624 4.656zm.432 3.552q-.689 0-.992-.32t-.304-.816v-.32q0-.495.304-.816t.992-.32q.672 0 .976.32.304.321.304.816v.32q0 .497-.304.816-.304.32-.976.32\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol